export default __webpack_public_path__ + "static/media/phone.01655eea.svg";